export class AuctionBid {
  id: number;
  auctionId: number;
  value: number;
  time: Date;
  cardId: number;
  rowVersion: Int8Array;

  constructor(auctionId: number, value: number) {
    this.auctionId = auctionId;
    this.value = value;
  }
}
